import { render, staticRenderFns } from "./base_mob_overview.vue?vue&type=template&id=4dde0d41"
import script from "./base_mob_overview.vue?vue&type=script&setup=true&lang=js"
export * from "./base_mob_overview.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports